import { Outlet } from "react-router-dom"

export default function Hoofdcodes() {
    return (<Outlet />)
}